/* V80: removed the old JS whitespace correction, which was tied to iOS viewport resize.
   Fixed header clearance is now reserved by --mh-fixed-header-height only. */
(function () {
  document.documentElement.style.removeProperty('--mh74-whitespace-correction');
})();
